"use client";

import DescriptionBlock from "@/components/entities/description-block";
import Image from "next/image";
import S from "./index.module.scss";
import { useTranslations } from "next-intl";
import { useAboutData } from "../../hooks/useAboutData";
import { useMedia } from "@/hooks/system/useMedia";

const AboutHeader = () => {
  const { isClient } = useMedia();
  const { data } = useAboutData();
  const t = useTranslations();

  const breadcrumbs = [{ title: t("home"), url: "/" }];

  if (!data) return null;

  return (
    <>
      <section className={S.wrapper}>
        <Image alt="Banner" src={data?.hero_block.background} width={1600} height={800} />
        <div className={S.textWrapper}>
          <h1 className={S.title}>{data?.hero_block.title} </h1>
          {data?.hero_block.description && isClient && (
            <p className={S.description} dangerouslySetInnerHTML={{ __html: data?.hero_block.description }} />
          )}
        </div>
      </section>
      <div className={S.descriptionWrapper}>
        <DescriptionBlock
          breadcrumbs={breadcrumbs}
          title={data?.about_company_block.title}
          description={data?.about_company_block.description}
        />
      </div>
    </>
  );
};

export default AboutHeader;
